import { render, staticRenderFns } from "./AddTypeName.vue?vue&type=template&id=81f8adf2&scoped=true"
import script from "./AddTypeName.vue?vue&type=script&lang=js"
export * from "./AddTypeName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f8adf2",
  null
  
)

export default component.exports